<main class="fixture-shell">
  <section class="fixture-header">
    <div>
      <p class="fixture-kicker">Local visual fixture</p>
      <h1>Chatbot Image Composition Controls</h1>
      <p>
        Review-safe Chat Window surface for <strong>{{ chatbotId }}</strong>. This route only matches on localhost with
        the <code>chatbotVisualFixture</code> query parameter and does not load auth, client, or customer data.
      </p>
    </div>
    <div class="fixture-route">
      <span>Route</span>
      <strong>/ai/chatbots/{{ chatbotId }}</strong>
      <code>?chatbotVisualFixture={{ state }}</code>
    </div>
  </section>

  <section class="fixture-toolbar">
    @for (option of fixtureStates; track option.key) {
      <a
        mat-stroked-button
        class="fixture-state-link"
        [class.fixture-state-link--active]="option.key === state"
        [routerLink]="['/ai/chatbots', chatbotId]"
        [queryParams]="{chatbotVisualFixture: option.key}">
        {{ option.label }}
      </a>
    }
  </section>

  <section class="fixture-meta">
    <span><strong>{{ activeState.label }}</strong>: {{ activeState.description }}</span>
    <span>Runtime remains read-only false and activation stays disabled.</span>
    <span>Request-scoped upload guidance stays visible in-surface.</span>
    <span>Backend generation actions stay hidden on this review-safe fixture route.</span>
  </section>

  @if (fixtureValidation.errors.length > 0) {
    <section class="fixture-alert">
      <h2>Validation preview</h2>
      <p>
        @if (fixtureValidation.categoryError) {
          <span>{{ fixtureValidation.categoryError }}</span>
        }
        @if (fixtureValidation.disclaimerError) {
          <span>{{ fixtureValidation.disclaimerError }}</span>
        }
        @for (error of fixtureValidation.activationErrors; track error) {
          <span>{{ error }}</span>
        }
      </p>
    </section>
  }

  <section class="fixture-surface">
    <app-frontend-settings
      [chatbotId]="chatbotId"
      [frontendForm]="frontendForm"
      [settingsForm]="settingsForm"
      [messagesForm]="messagesForm"
      [localizationForm]="localizationForm"
      [localizationVariantsForm]="localizationVariantsForm"
      [aiProductCardsEnabled]="false"
      [imageCompositionRuntimeReady]="imageCompositionRuntimeReady"
      [allowGenerativeActions]="false"
      [expandedPanel]="expandedPanel">
    </app-frontend-settings>
  </section>
</main>
